<template>
    <div class="shop-note">
        <div class="title">
            <img src="@/assets/img/pen-green.svg">
            直接輸入想要的商品
        </div>
        <div class="body">
            <p-textarea :value="note" :focus="focus" @input="onInput" :min-height="minHeight" placeholder="實際依店家現場供貨為準"></p-textarea>
        </div>
    </div>
</template>

<script>
    import AutoHeighTextarea from "../components/AutoHeighTextarea";

    export default {
        name: "Note",
        components: {
            'p-textarea': AutoHeighTextarea,
        },
        props: {
            note: {
                default: '',
                required: true,
            },
            minHeight: {
                default: '6em',
            },
            focus: {
                default: false,
            }
        },
        model: {
            prop: 'note',
            event: 'input',
        },
        methods: {
            onInput(note) {
                this.$emit('input', note);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .shop-note {
        .title {
            display: flex;
            justify-content: left;
            align-items: center;
            color: #339933;

            img {
                margin-right: 5px;
            }

        }

        .body {
            margin-top: 10px;
            font-size: 14px;
        }
    }
</style>